let aiResponse = null;

document
  .getElementById("toggleLang")
  .addEventListener("click", async function () {
    const enContent = document.querySelector(".lang-content.en");
    const arContent = document.querySelector(".lang-content.ar");

    const isEnglish = getComputedStyle(enContent).display !== "none";

    enContent.style.display = isEnglish ? "none" : "block";
    arContent.style.display = isEnglish ? "block" : "none";

    this.textContent = isEnglish ? "English" : "عربي";

    if (isEnglish) {
      await renderArabicContent(aiResponse);
    } else {
      await renderEnglishContent(aiResponse);
    }
  });

// Function to create a styled note item
function createNoteItem(note, type, percentage) {
  const li = document.createElement("li");
  li.classList.add("note-item", type);

  li.innerHTML = `
    <span class="note-label">${note} ${percentage}%</span>
    <div class="note-bar">
      <div class="note-bar-fill" style="width: ${percentage}%;">&nbsp;</div>
    </div>
  `;

  return li;
}

async function renderCardStylePyramid(
  components,
  containerId,
  type,
  lang = "en"
) {
  console.log("Rendering:", type);

  const container = document.getElementById(containerId);
  if (!container) {
    console.error("Container not found:", containerId);
    return;
  }

  if (!components || !components[type] || !Array.isArray(components[type])) {
    console.warn(`No data for ${type}`);
    return;
  }

  container.innerHTML = "";

  const colorMap = {
    "Top Notes": "#a4dd6e",
    "Middle Notes": "#7dcfb6",
    "Base Notes": "#d18700",
  };

  const notes = components[type];

  for (const note of notes) {
    const percentage = Math.max(5, Math.min(note.percentage, 100));
    const noteName = lang === "ar" ? note.name_ar : note.name_en;
    const imageUrl = await ModernFetchImage(note.name_en);

    const card = document.createElement("div");
    card.className = "note-card";
    card.innerHTML = `
      <img src="${imageUrl}" alt="${noteName}" onerror="this.src='fallback.jpg'" />
      <div class="note-bar-mini" style="--bar-color: ${colorMap[type]}; --bar-width: ${percentage}%">&nbsp;</div>
      <div class="note-name">${noteName}</div>
    `;
    container.appendChild(card);
  }
}

async function renderEnglishContent(data) {
  console.log("Inside renderEnglishContent");

  const frageName = data["Fragrance Name"];
  $("#product-name").append(frageName);

  // Sending perfume name to product page

  document.querySelector(".desc-en").textContent =
    data["Fragrance description EN"];
  $("#product-desc").append(data["Fragrance description EN"]);

  document.querySelector(".feelings-en").textContent =
    data["Feelings description EN"];

  await renderCardStylePyramid(data.Components, "top-notes-list", "Top Notes");
  await renderCardStylePyramid(
    data.Components,
    "middle-notes-list",
    "Middle Notes"
  );
  await renderCardStylePyramid(
    data.Components,
    "base-notes-list",
    "Base Notes"
  );

  const topNotes = data.Components["Top Notes"];
  const middleNotes = data.Components["Middle Notes"];
  const baseNotes = data.Components["Base Notes"];

  topNotes.forEach((note) => {
    document
      .getElementById("top-notes")
      .appendChild(createNoteItem(note.name_en, "top-note", note.percentage));
  });

  middleNotes.forEach((note) => {
    document
      .getElementById("middle-notes")
      .appendChild(createNoteItem(note.name_en, "top-note", note.percentage));
  });

  baseNotes.forEach((note) => {
    document
      .getElementById("base-notes")
      .appendChild(createNoteItem(note.name_en, "top-note", note.percentage));
  });
}

async function renderArabicContent(data) {
  console.log("Inside renderArabicContent");

  document.querySelector(".desc-ar").textContent =
    data["Fragrance description AR"];
  document.querySelector(".feelings-ar").textContent =
    data["Feelings description AR"];

  await renderCardStylePyramid(
    data.Components,
    "top-notes-list-ar",
    "Top Notes",
    "ar"
  );
  await renderCardStylePyramid(
    data.Components,
    "middle-notes-list-ar",
    "Middle Notes",
    "ar"
  );
  await renderCardStylePyramid(
    data.Components,
    "base-notes-list-ar",
    "Base Notes",
    "ar"
  );
}

// Testing AI response
// aiResponse = {
//   "Fragrance Name": "Spice Odyssey",
//   "Fragrance description EN":
//     "Spice Odyssey is a captivating masculine fragrance that blends spicy and oriental notes, perfect for romantic dates and night outs. Its balanced intensity ensures a noticeable presence without being overpowering, making it suitable for all seasons.",
//   "Fragrance description AR":
//     "سبايس أوديسي هو عطر رجالي ساحر يمزج بين النفحات الحارة والشرقية، مثالي للمواعيد الرومانسية والليالي الخارجية. توازنه المثالي يضمن حضورًا ملحوظًا دون أن يكون طاغيًا، مما يجعله مناسبًا لجميع الفصول.",
//   "Feelings description EN":
//     "Feel the allure of an exotic journey with Spice Odyssey, where the warmth of spices meets the mystery of oriental notes, creating an unforgettable aura of sophistication and charm.",
//   "Feelings description AR":
//     "اشعر بجاذبية رحلة غامضة مع سبايس أوديسي، حيث يلتقي دفء التوابل مع غموض النفحات الشرقية، مما يخلق هالة لا تُنسى من الأناقة والجاذبية.",
//   Components: {
//     "Top Notes": [
//       { name_en: "Cinnamon", name_ar: "قرفة", percentage: 15 },
//       { name_en: "Bergamot", name_ar: "برغموت", percentage: 10 },
//     ],
//     "Middle Notes": [
//       { name_en: "Amber", name_ar: "عنبر", percentage: 25 },
//       { name_en: "Saffron", name_ar: "زعفران", percentage: 15 },
//     ],
//     "Base Notes": [
//       { name_en: "Musk", name_ar: "مسك", percentage: 20 },
//       { name_en: "Sandalwood", name_ar: "خشب الصندل", percentage: 15 },
//     ],
//   },
// };
// document.addEventListener("DOMContentLoaded", () => {
//   renderEnglishContent(aiResponse);
// });
